"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typestyle_1 = require("typestyle");

exports.heading = function (color) {
  return typestyle_1.style({
    fontWeight: "bold"
  }, {
    color: color ? color : "#333333"
  });
};

exports.description = function (color) {
  return typestyle_1.style({
    color: color
  });
};

exports.container = typestyle_1.style({
  width: "100%"
}, {
  background: "#f1f1f1"
});